import React from "react";

export default function Main({ children }) {
  return (
    <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
      {children}
    </main>
  );
}
